import apiClient, { API_BASE_URL } from './apiClient';

// ============================================================
// Types — matching backend Go models (FD110, FD111, FD112..FD116)
// ============================================================

export interface FD112 {
  fd112_01: string;   // 採購單號
  fd112_02: number;   // 產品項次
  fd112_03: number;   // 色號項次
  fd112_11: string;   // 色號代號
  fd112_111: string;
  fd112_112: string;
  fd112_12: number;
  fd112_13: number;   // 顏色數量
  fd112_14: number;   // 包缸費
  fd112_15: number;
  fd112_151: number;
  fd112_152: number;
  fd112_153: number;
  fd112_154: number;
  fd112_16: string;   // 備用
  fd112_17: string;
  fd112_18: string;
  fd112_19: string;
  fd112_24: number;
  fd112_25: string;
}

export interface FD113 {
  fd113_01: string;   // 採購單號
  fd113_02: number;   // 產品項次
  fd113_03: number;   // 佣金項次
  fd113_11: string;   // 佣金收取對象
  fd113_12: number;   // 佣金數量
}

export interface FD114 {
  fd114_01: string;   // 採購單號
  fd114_02: number;   // 附件項次
  fd114_11: string;   // 檔案路徑
  fd114_12: string;   // 檔案名稱
}

export interface FD115 {
  fd115_01: string;   // 採購單號
  fd115_02: number;   // 產品項次
  fd115_03: number;   // 佣金項次
  fd115_11: string;   // 佣金支付對象
  fd115_15: number;   // 佣金數量
}

export interface FD116 {
  fd116_01: string;   // 採購單號
  fd116_02: number;   // 產品項次
  fd116_03: number;   // 檢驗項次
  fd116_11: string;   // 測試項目代號
  fd116_12: string;   // 測試項目名稱
  fd116_13: string;   // 檢驗規範代號
  fd116_14: string;   // 允收標準
  fd116_15: string;   // 備註
}

export interface FD111 {
  fd111_01: string;        // 採購單號
  fd111_02: number;        // 產品項次
  fd111_10: string;        // 產品大類
  fd111_11: string;        // 產品子類
  fd111_12: string;        // 產品名稱
  fd111_13: string;        // S/C NO
  fd111_14: number;        // S/C項次
  fd111_15: number;        // 採購數量
  fd111_16: string;        // 單位
  fd111_17: number;        // 採購單價
  fd111_18: number;        // 採購金額
  fd111_19: string | null; // 預定交期
  fd111_25: number;        // 折讓單價
  fd111_26: number;        // 應付單價
  fd111_27: string;        // 驗貨方式
  fd111_29: string;        // ASSORT (Y/N)
  fd111_30: number;        // 允收量
  fd111_301: number;       // 允收比率
  fd111_302: number;       // 允收增加量
  fd111_31: number;        // 應付佣金OVER/PRICE
  fd111_32: number;        // 應付佣金BASIS ON
  fd111_33: number;        // 應付佣金佣金率
  fd111_34: number;        // 應付佣金數量
  fd111_36: number;        // 應收佣金OVER/PRICE
  fd111_37: number;        // 應收佣金BASIS ON
  fd111_38: number;        // 應收佣金佣金率
  fd111_39: number;        // 應收佣金數量
  fd111_40: number;        // 包缸費合計
  fd111_401: number;       // 包缸費備用
  fd111_51: string;        // 產品規格
  fd111_52: string;        // 加工別
  fd111_53: string;        // 幅寬(針孔內)
  fd111_54: string;        // 幅寬(針孔外)
  fd111_55: string;        // 碼重
  fd111_56: string;        // 米平方重
  fd111_57: string;        // 檢驗規範旗標
  // Sub-detail associations
  colors?: FD112[];
  receivable_comm_items?: FD113[];
  payable_comm_items?: FD115[];
  inspections?: FD116[];
}

export interface FD110 {
  fd110_01: string;        // 採購單號 (PK)
  fd110_10: string;        // S/C NO
  fd110_11: string | null; // 採購日期
  fd110_12: string;        // 分包商代號
  fd110_13: string;        // 收貨地址
  fd110_14: string;        // 交易條件說明
  fd110_141: string;       // 交易條件代號
  fd110_15: string;        // 付款條件說明
  fd110_151: string;       // 付款條件代號
  fd110_16: string;        // 包裝方式代號
  fd110_161: string;       // 包裝方式說明
  fd110_17: string;        // 業務員代號
  fd110_18: string;        // 部門代號
  fd110_19: string;        // 幣別
  fd110_20: number;        // 匯率
  fd110_23: number;        // 原幣總金額
  fd110_24: number;        // 台幣/人民幣總金額
  fd110_25: string;        // 備用
  fd110_28: string;        // 購貨類別 (1/2/3)
  fd110_29: string;        // 結案狀態 (N/P)
  fd110_30: string;        // QC人員代號
  fd110_31: string;        // 採購人員代號
  fd110_32: string;        // 採購人員部門
  fd110_33: string;        // 收貨公司代號
  fd110_34: string;        // 備用
  fd110_40: number;        // 有效旗標
  fd110_42: string;        // 備註說明
  fd110_421: string;       // 備註代號
  fd110_43: number;        // 明細項數
  fd110_44: string;        // 品質要求代號
  fd110_441: string;       // 品質要求說明
  fd110_46: string;        // 原料/半成品/成品名稱
  fd110_47: string | null; // 核准日期
  fd110_48: string | null; // 建檔日期
  fd110_50: number;        // 備用數值
  fd110_51: string;        // 備用字串
  fd110_53: string;        // 區域碼
  fd110_55: boolean;       // 三聯式發票
  fd110_71: string;        // 備用旗標
  fd110_72: string;        // 備用
  fd110_80: string;        // 審核狀態
  fd110_90: number;        // 版次
  fd110_91: string;        // 建檔人員
  fd110_92: string | null; // 修改日期
  fd110_93: string;        // 修改時間
  fd110_94: string;        // 刪除旗標
  fd110_41: string;        // SHIPPING MARK
  fd110_45: string;        // 樣布需要量代號
  fd110_54: boolean;       // 內部交易
  // Associations
  details?: FD111[];
  attachments?: FD114[];
}

// ============================================================
// SC Import types
// ============================================================

export interface SCListItem {
  sc_no: string;
  sc_date: string | null;
  customer_code: string;
  customer_name: string;
  salesperson: string;
  currency: string;
  total_amount: number;
  item_count: number;
}

export interface SCPreviewResponse {
  master: Partial<FD110>;
  details: FD111[];
}

// ============================================================
// Request / Response types
// ============================================================

export interface D201ListResponse {
  data: FD110[];
  total: number;
  page: number;
  size: number;
}

export interface D201CreateRequest {
  master: Partial<FD110>;
  details: Partial<FD111>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const d201Api = {
  async list(page = 1, size = 20, keyword?: string): Promise<D201ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/pwd201f1', { params });
    return res.data;
  },

  async get(poNo: string): Promise<FD110> {
    const res = await apiClient.get(`/api/pwd201f1/${encodeURIComponent(poNo)}`);
    return res.data;
  },

  async create(data: D201CreateRequest): Promise<FD110> {
    const res = await apiClient.post('/api/pwd201f1', data);
    return res.data;
  },

  async update(poNo: string, data: D201CreateRequest): Promise<FD110> {
    const res = await apiClient.put(`/api/pwd201f1/${encodeURIComponent(poNo)}`, data);
    return res.data;
  },

  async delete(poNo: string): Promise<void> {
    await apiClient.delete(`/api/pwd201f1/${encodeURIComponent(poNo)}`);
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/pwd201f1/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },

  async listApprovedSCs(keyword?: string, limit?: number): Promise<SCListItem[]> {
    const params: Record<string, string | number> = {};
    if (keyword) params.keyword = keyword;
    if (limit) params.limit = limit;
    const res = await apiClient.get('/api/pwd201f1/sc-list', { params });
    return res.data.data || [];
  },

  async previewFromSC(scNo: string): Promise<SCPreviewResponse> {
    const res = await apiClient.get(`/api/pwd201f1/from-sc/${encodeURIComponent(scNo)}`);
    return res.data;
  },

  async submit(poNo: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/pwd201f1/${encodeURIComponent(poNo)}/submit`);
    return res.data;
  },

  async approve(poNo: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/pwd201f1/${encodeURIComponent(poNo)}/approve`);
    return res.data;
  },

  async reject(poNo: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/pwd201f1/${encodeURIComponent(poNo)}/reject`);
    return res.data;
  },

  async writeoff(poNo: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/pwd201f1/${encodeURIComponent(poNo)}/writeoff`, { comment: comment || '' });
    return res.data;
  },

  getPrintUrl(poNo: string, options?: { reports?: string }): string {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    const params = new URLSearchParams({ token });
    if (options?.reports) {
      params.set('reports', options.reports);
    }
    return `${API_BASE_URL}/api/pwd201f1/${encodeURIComponent(poNo)}/print?${params.toString()}`;
  },

  async getHistory(poNo: string): Promise<ApprovalEvent[]> {
    const res = await apiClient.get(`/api/pwd201f1/${encodeURIComponent(poNo)}/history`);
    return res.data.events || [];
  },
};

// ============================================================
// Approval history types
// ============================================================

export interface ApprovalEvent {
  action: string;
  user: string;
  date: string | null;
  note: string;
}
